/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measure the change from one value to another in percentage terms. The result is positive for an increase and negative for a decrease.`)
};

const es_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mide el cambio de un valor a otro en términos porcentuales. El resultado es positivo si aumenta y negativo si disminuye.`)
};

const de_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miss die Veränderung von einem Wert zum anderen in Prozent. Das Ergebnis ist positiv bei einem Anstieg und negativ bei einem Rückgang.`)
};

const nl_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet de verandering van de ene naar de andere waarde in procenten. Het resultaat is positief bij een stijging en negatief bij een daling.`)
};

const fr_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesurez la variation d'une valeur à une autre en pourcentage. Le résultat est positif pour une augmentation et négatif pour une diminution.`)
};

const it_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura la variazione da un valore a un altro in termini percentuali. Il risultato è positivo per un aumento e negativo per un calo.`)
};

const pt_br2_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça a variação de um valor para outro em termos percentuais. O resultado é positivo para um aumento e negativo para uma diminuição.`)
};

const pt_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça a variação de um valor para outro em termos percentuais. O resultado é positivo para um aumento e negativo para uma diminuição.`)
};

const ja_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ある値から別の値への変化をパーセントで測定。結果は増加なら正、減少なら負になります。`)
};

const zh_pct_change_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以百分比形式衡量一个数值到另一个数值的变化。结果为正表示增长，为负表示减少。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_intro", locale)
	if (locale === "en") return en_pct_change_intro(inputs)
	if (locale === "es") return es_pct_change_intro(inputs)
	if (locale === "de") return de_pct_change_intro(inputs)
	if (locale === "nl") return nl_pct_change_intro(inputs)
	if (locale === "fr") return fr_pct_change_intro(inputs)
	if (locale === "it") return it_pct_change_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_intro(inputs)
	if (locale === "pt") return pt_pct_change_intro(inputs)
	if (locale === "ja") return ja_pct_change_intro(inputs)
	return zh_pct_change_intro(inputs)
};